import { render, staticRenderFns } from "./economic-programming-table.vue?vue&type=template&id=375af8a2&scoped=true"
import script from "./economic-programming-table.vue?vue&type=script&lang=js"
export * from "./economic-programming-table.vue?vue&type=script&lang=js"
import style0 from "./economic-programming-table.vue?vue&type=style&index=0&id=375af8a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375af8a2",
  null
  
)

export default component.exports